<script lang="ts">
  import { onMount } from 'svelte';
  import type { ApiClient, TimeBounds } from '../lib/api';
  import GuardDutyFindingList from '../lib/GuardDutyFindingList.svelte';
  import Loading from '../lib/Loading.svelte';
  import type { GuardDutyFinding, SeverityBand } from '../lib/types';

  let { api }: { api: ApiClient } = $props();
  let findings = $state<GuardDutyFinding[]>([]);
  let cursor = $state<string | null>(null);
  let minimumSeverity = $state<SeverityBand>('medium');
  let suppressed = $state('exclude');
  let acknowledged = $state('exclude');
  let findingType = $state('');
  let loading = $state(true);
  let error = $state('');
  let bounds = $state<TimeBounds | null>(null);

  async function load(next = '') {
    loading = true;
    try {
      const query = new URLSearchParams({ minimumSeverity, suppressed, acknowledged });
      if (findingType.trim()) query.set('findingType', findingType.trim());
      if (next) query.set('cursor', next);
      if (next && bounds) {
        query.set('from', bounds.from);
        query.set('to', bounds.to);
      }
      const result = await api.guardDutyFindings(`?${query}`);
      findings = next ? [...findings, ...result.items] : result.items;
      cursor = result.nextCursor;
      bounds = { from: result.from, to: result.to };
      error = '';
    } catch (reason) {
      error = reason instanceof Error ? reason.message : 'GuardDuty findings could not be loaded.';
    } finally {
      loading = false;
    }
  }

  onMount(() => load());
</script>

<section class="page-heading">
  <div><p class="eyebrow">Previous 30 days</p><h1>GuardDuty findings</h1><p>Security findings received from mapped commercial and GovCloud accounts.</p></div>
</section>
<form class="filter-bar" onsubmit={(event) => { event.preventDefault(); load(); }}>
  <label>Minimum severity<select bind:value={minimumSeverity}><option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option><option value="critical">Critical</option></select></label>
  <label>Suppression<select bind:value={suppressed}><option value="exclude">Unsuppressed only</option><option value="include">Include suppressed</option><option value="only">Suppressed only</option></select></label>
  <label>Acknowledgement<select bind:value={acknowledged}><option value="exclude">Unacknowledged only</option><option value="include">Include acknowledged</option><option value="only">Acknowledged only</option></select></label>
  <label class="type-filter">Exact finding type<input bind:value={findingType} placeholder="For example Recon:EC2/…" /></label>
  <button class="secondary" type="submit">Apply filters</button>
</form>
{#if error}<p class="inline-error" role="alert">{error}</p>{/if}
{#if loading && findings.length === 0}<Loading />
{:else if findings.length === 0}<section class="empty"><h2>No matching findings</h2><p>Try lowering the severity or including hidden findings.</p></section>
{:else}
  <GuardDutyFindingList {findings} />
  {#if cursor}<button class="secondary load-more" disabled={loading} onclick={() => load(cursor ?? '')}>{loading ? 'Loading…' : 'Load more'}</button>{/if}
{/if}
